import { render, staticRenderFns } from "./PatientList.vue?vue&type=template&id=90a276c2&scoped=true&"
import script from "./PatientList.vue?vue&type=script&lang=ts&"
export * from "./PatientList.vue?vue&type=script&lang=ts&"
import style0 from "./PatientList.vue?vue&type=style&index=0&id=90a276c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a276c2",
  null
  
)

export default component.exports